var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTally3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32C27.578 32 24 35.578 24 40V472C24 476.422 27.578 480 32 480S40 476.422 40 472V40C40 35.578 36.422 32 32 32ZM288 32C283.578 32 280 35.578 280 40V472C280 476.422 283.578 480 288 480S296 476.422 296 472V40C296 35.578 292.422 32 288 32ZM160 32C155.578 32 152 35.578 152 40V472C152 476.422 155.578 480 160 480S168 476.422 168 472V40C168 35.578 164.422 32 160 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTally3);
export default __webpack_public_path__ + "static/media/tally-3.3c78576ff24095e2f177e119d0008e24.svg";
export { ForwardRef as ReactComponent };